// [BD feat] FAQ — bd-faq.js
// Dev note: "Two states of dropdowns for CMS — Toggle ''show content'' or Text inside of drop down".
//  - show content ON (desktop): every answer is open and the rows are not interactive (state 1, 2979:4849)
//  - show content OFF or mobile: collapsed rows that open/close on click (state 2 / 2881:3455)
// One row open at a time in dropdown mode (matches the state frames, which show a single open row).
(function () {
  'use strict';

  var DESKTOP = '(min-width: 60em)';

  function init(section) {
    if (!section || section.dataset.bdFaqBound) return;
    section.dataset.bdFaqBound = '1';

    var items = [].slice.call(section.querySelectorAll('[data-bd-faq-item]'));
    if (!items.length) return;
    var showContent = section.dataset.bdFaqShowContent === 'true';
    var mq = window.matchMedia ? window.matchMedia(DESKTOP) : null;

    function isStatic() {
      return showContent && mq && mq.matches;
    }

    function setOpen(item, open) {
      var trigger = item.querySelector('[data-bd-faq-trigger]');
      var panel = item.querySelector('[data-bd-faq-panel]');
      item.classList.toggle('is-open', open);
      // [BD feat] Store (homepage) rows are the general.css .bd-faq-row atom → its open modifier (question
      // #303030, answer padding). Guarded so a pre-launch item never gains the class.
      if (item.classList.contains('bd-faq-row')) item.classList.toggle('bd-faq-row--open', open);
      // [/BD feat]
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    }

    // [BD feat] Store (homepage): two category toggles switch the visible question group (dev note: "2x Toggels
    // to switch the state and show a second FAQ Dropdown Menu"). Buttons carry aria-pressed; the group lists are
    // hidden/shown; every row closes on a switch. Clicking the active toggle does nothing (one group is always on).
    var categories = [].slice.call(section.querySelectorAll('[data-bd-faq-category]'));
    var groups = [].slice.call(section.querySelectorAll('[data-bd-faq-group]'));

    function setGroup(id) {
      groups.forEach(function (group) { group.hidden = group.dataset.bdFaqGroup !== id; });
      categories.forEach(function (button) {
        var on = button.dataset.bdFaqCategory === id;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.classList.toggle('bd-faq__category--inactive', !on);
        button.classList.toggle('bd-faq-category--inactive', !on);
        // [BD feat] Figma QA 27.10. comment 1981960431: knob slides via the CSS transition; the label runs its
        // fade-out/fade-in once per switch — remove + reflow + re-add restarts the keyframes reliably.
        var label = button.querySelector('.bd-faq__category-label');
        if (label) {
          label.classList.remove('is-switching');
          void label.offsetWidth;
          label.classList.add('is-switching');
        }
        // [/BD feat]
      });
      items.forEach(function (item) { setOpen(item, false); });
    }

    categories.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.getAttribute('aria-pressed') === 'true') return;
        setGroup(button.dataset.bdFaqCategory);
      });
    });

    function revealGroupOf(item) {
      var group = item.closest ? item.closest('[data-bd-faq-group]') : null;
      if (group && group.hidden) setGroup(group.dataset.bdFaqGroup);
    }
    // [/BD feat]

    // Static mode: everything open, rows inert. Dropdown mode: everything collapsed (the design default).
    function applyMode() {
      var stat = isStatic();
      items.forEach(function (item) {
        var trigger = item.querySelector('[data-bd-faq-trigger]');
        if (trigger) {
          if (stat) trigger.setAttribute('aria-disabled', 'true');
          else trigger.removeAttribute('aria-disabled');
        }
        setOpen(item, stat);
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-bd-faq-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (isStatic()) return;
        var open = !item.classList.contains('is-open');
        items.forEach(function (other) {
          if (other !== item) setOpen(other, false);
        });
        setOpen(item, open);
      });
    });

    applyMode();

    if (mq) {
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', applyMode);
      else if (typeof mq.addListener === 'function') mq.addListener(applyMode);
    }

    section.bdFaq = { open: function (item) { if (!isStatic()) { revealGroupOf(item); items.forEach(function (o) { setOpen(o, o === item); }); } } };
  }

  document.querySelectorAll('.bd-faq').forEach(init);

  // Shopify theme editor: sections re-render without a page load; selecting a block opens its row.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bd-faq').forEach(init);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest ? e.target.closest('[data-bd-faq-item]') : null;
    var section = item ? item.closest('.bd-faq') : null;
    if (item && section && section.bdFaq) section.bdFaq.open(item);
  });
})();
// [BD feat] FAQ
